import { ComponentProps } from 'react';
import CARDANO from './currencies/ADA.svg';
import ARBITRUM from './currencies/ARB.svg';
import BEP20 from './currencies/BNB.svg';
import BTC from './currencies/BTC.svg';
import ERC20 from './currencies/ETH.svg';
import POLYGON from './currencies/MATIC.svg';
import SOLANA from './currencies/SOL.svg';
import TON from './currencies/TON.svg';
import TRC20 from './currencies/TRX.svg';
import TEZOS from './currencies/XTZ.svg';
import HAQQ from './networks/HAQQ.svg';
import SEPA from './networks/SEPA.svg';
import SWIFT from './networks/SWIFT.svg';

export interface NetworkImageProps extends Omit<ComponentProps<'img'>, 'src' | 'srcSet'> {
  network: string;
}

export const networkImages: Record<string, string | undefined> = {
  SEPA,
  SEPA_INSTANT: SEPA,
  SWIFT,
  ERC20,
  TRC20,
  HAQQ,
  POLYGON,
  BTC_SEGWIT: BTC,
  BTC_LEGACY: BTC,
  BEP20,
  CARDANO,
  TEZOS,
  ARBITRUM,
  TON,
  SOLANA,
};

export function NetworkImage({ network, alt, ...props }: NetworkImageProps) {
  const src = networkImages[network];

  return src ? <img src={src} alt={alt ?? network} {...props} /> : null;
}
